import React from 'react'
import ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'
import injectTapEventPlugin from 'react-tap-event-plugin'
import {MuiThemeProvider, createMuiTheme} from 'material-ui/styles'
import cyan from 'material-ui/colors/cyan'
import purple from 'material-ui/colors/purple'
import grey from 'material-ui/colors/grey'
import App from './App'

injectTapEventPlugin()

const theme = createMuiTheme({
  palette: {
    primary: {
      light: cyan[100],
      main: cyan[700],
      dark: cyan[700],
      contrastText: 'white',
    },
    secondary: {
      light: purple[400],
      main: purple[800],
      dark: purple[800],
      contrastText: 'white',
    },
    grey: {
      light: grey[300],
      main: grey[600],
      dark: grey[800],
      contrastText: 'white',
    },
  },
})

ReactDOM.render((
  <MuiThemeProvider theme={theme}>
    <App />
  </MuiThemeProvider>
), document.getElementById('root'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js